<template>
  <main class="accept-page">
    <section class="accept-card">
      <div class="accept-hero">
        <div class="brand-mark"><img src="/img/boarua-icon-concept-v1.png" alt="" /></div>
        <h1>BOARUA</h1>
        <p>Convite administrativo</p>
      </div>

      <v-form ref="form" class="accept-form" @submit.prevent="submit">
        <h2>Concluir cadastro</h2>
        <v-text-field v-model="form.name" label="Nome completo" outlined :rules="[$rules.required]" />
        <v-text-field v-model="form.email" label="E-mail" outlined readonly />
        <v-text-field
          v-model="form.password"
          :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          :type="showPassword ? 'text' : 'password'"
          label="Senha"
          outlined
          :rules="[$rules.required]"
          @click:append="showPassword = !showPassword"
        />
        <v-btn block depressed color="primary" height="52" type="submit" :loading="loading">
          Aceitar convite
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
        <router-link class="login-link" to="/login">Já tenho acesso</router-link>
      </v-form>
    </section>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "AcceptAdminInvite",
  data() {
    return {
      loading: false,
      showPassword: false,
      form: {
        token: "",
        name: "",
        email: "",
        password: "",
      },
    };
  },
  mounted() {
    this.form.token = this.$route.query.token || "";
    this.form.email = this.$route.query.email || "";
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        await axios.post("/association-admins/accept", this.form);
        this.$dialog.notify.success("Convite aceito. Você já pode acessar o painel.", { position: "top-right", timeout: 4000 });
        this.$router.push({ path: "/login", query: { email: this.form.email } });
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.accept-page {
  min-height: 100vh;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #cfe0d9;
}

.accept-card {
  width: min(100%, 430px);
  overflow: hidden;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 26px 70px rgba(6, 52, 32, 0.17);
}

.accept-hero {
  min-height: 210px;
  padding: 30px;
  color: #ffffff;
  background: #2b7567;

  h1 {
    margin: 18px 0 6px;
    font-size: 34px;
    font-weight: 900;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.82);
  }
}

.brand-mark {
  width: 52px;
  height: 52px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #ffffff;
  border-radius: 10px;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.accept-form {
  padding: 28px;

  h2 {
    margin: 0 0 20px;
    color: #111827;
    font-size: 23px;
  }
}

.login-link {
  display: block;
  margin-top: 18px;
  color: #286f61;
  font-weight: 800;
  text-align: center;
  text-decoration: none;
}
</style>
